import Vue from 'vue'
import Vuex from 'vuex'
import {
  // VIEW_TABLE
  VIEW_GRID,
  SORT_123
} from '@/utils/constants'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    allProjectsData: null,
    projectTextSearch: null,
    projectStatusFilters: {
      publish: {
        isSelected: true,
        label: 'Published'
      },
      private: {
        isSelected: true,
        label: 'Private'
      },
      draft: {
        isSelected: true,
        label: 'Draft'
      }
    },
    projectYearFilters: null,
    projectTermFilters: {},
    projectSort: SORT_123,
    projectView: VIEW_GRID,
    taxonomies: null,
    noUser: false
  },
  mutations: {
    SET_ALL_PROJECTS_DATA(state, data) {
      state.allProjectsData = data
    },
    SET_PROJECT_TEXT_SEARCH(state, s) {
      state.projectTextSearch = s
    },
    SET_PROJECT_STATUS_FILTERS(state, filters) {
      state.projectStatusFilters = filters
    },
    SET_PROJECT_YEAR_FILTERS(state, filters) {
      state.projectYearFilters = filters
    },
    SET_PROJECT_TERM_FILTERS(state, filters) {
      state.projectTermFilters = filters
    },
    SET_PROJECT_SORT(state, sort) {
      state.projectSort = sort
    },
    SET_PROJECT_VIEW(state, view) {
      state.projectView = view
    },
    SET_TAXONOMIES(state, data) {
      state.taxonomies = data
    },
    SET_NO_USER(state, value) {
      state.noUser = value
    }
  },
  actions: {
    setAllProjectsData(context, data) {
      context.commit('SET_ALL_PROJECTS_DATA', data)
    },
    setProjectTextSearch(context, s) {
      context.commit('SET_PROJECT_TEXT_SEARCH', s)
    },
    setProjectStatusFilters(context, filters) {
      context.commit('SET_PROJECT_STATUS_FILTERS', filters)
    },
    setProjectYearFilters(context, filters) {
      context.commit('SET_PROJECT_YEAR_FILTERS', filters)
    },
    setProjectTermFilters(context, filters) {
      context.commit('SET_PROJECT_TERM_FILTERS', filters)
    },
    setProjectSort(context, sort) {
      context.commit('SET_PROJECT_SORT', sort)
    },
    setProjectView(context, view) {
      context.commit('SET_PROJECT_VIEW', view)
    },
    setTaxonomies(context, data) {
      context.commit('SET_TAXONOMIES', data)
    },
    setNoUser(context, value) {
      context.commit('SET_NO_USER', value)
    }
  },
  getters: {
    allProjectsData: state => {
      return state.allProjectsData
    },
    projectTextSearch: state => {
      return state.projectTextSearch
    },
    projectStatusFilters: state => {
      return state.projectStatusFilters
    },
    projectYearFilters: state => {
      return state.projectYearFilters
    },
    projectTermFilters: state => {
      return state.projectTermFilters
    },
    projectSort: state => {
      return state.projectSort
    },
    projectView: state => {
      return state.projectView
    },
    taxonomies: state => {
      return state.taxonomies
    },
    noUser: state => {
      return state.noUser
    }
  }
})
